import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductProtectionPlans from 'data-hooks/useProductProtectionPlans';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPAddProtectionPlanEvent from 'data-hooks/useEvents/usePDPAddProtectionPlanEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePDPPrice from 'data-hooks/usePDPPrice';
import PDPProtectionPlanSelectorUI from './PDPProtectionPlanSelectorUI';
import useSetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useSetPdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelectorPlaceholder';
function getPrice(percentage, priceData) {
  if (priceData.price?.original_price) {
    return Math.round((priceData.optionPrice + priceData.price.original_price) * percentage / 100);
  }
  return null;
}
const PDPProtectionPlanSelectorInner = t0 => {
  const $ = _c(11);
  const {
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const {
    loading
  } = usePDPBasicDetails();
  const {
    loading: protectionPlanLoading,
    data: protectionPlansData
  } = useProductProtectionPlans();
  const {
    data: t2
  } = usePDPOptions();
  const {
    allProtectionPlanTypes
  } = t2;
  const setSelectedProtectionPlanId = useSetPdpSelectedProtectionPlanId();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    addProtectionPlanEvent
  } = usePDPAddProtectionPlanEvent();
  let t3;
  if ($[0] !== allProtectionPlanTypes || $[1] !== priceData) {
    t3 = allProtectionPlanTypes ? allProtectionPlanTypes.map(plan => ({
      ...plan,
      plan_price: getPrice(plan?.plan_percent || 0, priceData || {})
    })) : [];
    $[0] = allProtectionPlanTypes;
    $[1] = priceData;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const allPlans = t3;
  let t4;
  if ($[3] !== addProtectionPlanEvent || $[4] !== allPlans || $[5] !== isLayoutRevamp || $[6] !== loading || $[7] !== protectionPlanLoading || $[8] !== protectionPlansData?.meta || $[9] !== setSelectedProtectionPlanId) {
    t4 = protectionPlansData?.meta?.eligible_protection_planids?.length > 0 ? <PDPProtectionPlanSelectorUI allProtectionPlanTypes={allPlans} loading={loading && protectionPlanLoading} meta={protectionPlansData?.meta} isLayoutRevamp={isLayoutRevamp} onProtectionPlanSelection={planId => {
      setSelectedProtectionPlanId(planId);
      const selectedPlan = allPlans.find(p => p.plan_id === planId);
      if (selectedPlan) {
        addProtectionPlanEvent(selectedPlan);
      }
    }} /> : null;
    $[3] = addProtectionPlanEvent;
    $[4] = allPlans;
    $[5] = isLayoutRevamp;
    $[6] = loading;
    $[7] = protectionPlanLoading;
    $[8] = protectionPlansData?.meta;
    $[9] = setSelectedProtectionPlanId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
PDPProtectionPlanSelectorInner.propTypes = {
  isLayoutRevamp: PropTypes.bool
};
const PDPProtectionPlanSelector = props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.isLayoutRevamp) {
    t0 = <PDPProtectionPlanSelectorPlaceholder isLayoutRevamp={props.isLayoutRevamp} />;
    $[0] = props.isLayoutRevamp;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PDPProtectionPlanSelectorInner {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <SuspenseWithLoader fallback={t0}>{t1}</SuspenseWithLoader>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default PDPProtectionPlanSelector;